import { Component, OnInit } from '@angular/core'
import { AirportsService } from '../../../../services/airports.service'
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { ModalConfirmComponent } from '../../../../components/modal-confirm/modal-confirm.component'
import { Location } from '@angular/common'

@Component({
  selector: 'app-airports-list',
  templateUrl: './airports-list.component.html',
  styleUrls: ['./airports-list.component.scss'],
})
export class AirportsListComponent implements OnInit {
  public headersTable: string[] = ['title', 'isActive', 'actions']
  public airport: any[] = []

  constructor (
    public airportsService: AirportsService,
    public snackBar: MatSnackBar,
    private readonly location: Location,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit () {
    this.listAirports()
  }

  listAirports () {
    this.airportsService.list().then(
      response => {
        this.airport = response.results
      },
      error => {
        console.log(error)
        this.snackBar.open(error.error.message)
      },
    )
  }

  convertStatus (isActive) {
    if (isActive) {
      return 'Ativo'
    }

    return 'Inativo'
  }

  remove (id) {
    this.dialog
      .open(ModalConfirmComponent, {
        width: '500px',
        data: {
          text: 'Deseja remover essa Aeroporto?',
          buttonConfirmText: 'Remover',
        },
      })
      .afterClosed()
      .toPromise()
      .then(async result => {
        if (result && result !== 'cancel') {
          return this.airportsService.deleteAirport(id).then(
            async response => {
              this.listAirports()
              this.snackBar.open('Aeroporto removida com sucesso.')
            },
            error => {
              console.log(error)
              this.snackBar.open(error.error.message)
            },
          )
        }
      })
      .catch(err => {
        this.snackBar.open(err.message)
      })
  }
}
